import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clains-layout',
  templateUrl: './clains-layout.component.html'
})
export class ClainsLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
